export enum WizardTabs {
  GENERAL = 'GENERAL',
  PERMISSIONS = 'PERMISSIONS',
}
